/* ===== Pink Paw Home — global.js ===== */
(function () {
  'use strict';

  var routes = window.ppRoutes || {};
  var moneyFormat = window.ppMoneyFormat || '${{amount}}';

  /* ---------- money formatting (mirrors Shopify's money filter) ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(num, size) {
      var n = num + '';
      while (n.length < size) n = '0' + n;
      return n;
    }
    function withCommas(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = moneyFormat.match(placeholderRegex);
    var formatString = match ? match[1] : 'amount';

    switch (formatString) {
      case 'amount': value = withCommas(cents, 2); break;
      case 'amount_no_decimals': value = withCommas(cents, 0); break;
      case 'amount_with_comma_separator': value = withCommas(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withCommas(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withCommas(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = withCommas(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withCommas(cents, 2, ' ', '.'); break;
      default: value = withCommas(cents, 2);
    }
    return moneyFormat.replace(placeholderRegex, value);
  }

  /* ---------- toast ---------- */
  var toastEl = document.getElementById('ppToast');
  var toastTimer;
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }
  window.ppToast = showToast;

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('ppCartDrawer');
  var overlay = document.getElementById('ppCartOverlay');
  var itemsEl = document.getElementById('ppCartItems');
  var subtotalEl = document.getElementById('ppCartSubtotal');
  var badgeEls = document.querySelectorAll('[data-pp-cart-count]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.ppOpenCart = openCart;

  function updateBadges(count) {
    badgeEls.forEach(function (el) {
      el.textContent = count;
      el.style.transform = 'scale(1.4)';
      setTimeout(function () { el.style.transform = 'scale(1)'; }, 200);
    });
  }

  function renderCart(cart) {
    if (!itemsEl) return;
    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="pp-cart-empty">Your cart is empty — add something cozy from the shop.</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item, i) {
        var img = item.image
          ? item.image.replace(/(\.[^.]*)$/, '_120x120$1')
          : '';
        var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<div class="pp-ci-price">' + item.variant_title + '</div>' : '';
        return '' +
          '<div class="pp-cart-item">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '<div class="pp-ci-info">' +
              '<div class="pp-ci-name">' + item.product_title + '</div>' +
              variantLabel +
              '<div class="pp-ci-price">' + formatMoney(item.final_price) + '</div>' +
              '<div class="pp-ci-qty">' +
                '<button type="button" data-pp-qty="dec" data-line="' + (i + 1) + '" aria-label="Decrease">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-pp-qty="inc" data-line="' + (i + 1) + '" aria-label="Increase">+</button>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="pp-ci-remove" data-pp-qty="remove" data-line="' + (i + 1) + '">Remove</button>' +
          '</div>';
      }).join('');
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateBadges(cart.item_count);
  }

  function fetchCart() {
    return fetch(routes.cartFetch, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(line, quantity) {
    if (drawer) drawer.classList.add('is-loading');
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { showToast('Could not update the cart — please try again.'); })
      .finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }

  function addToCart(variantId, quantity, productTitle) {
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        return fetchCart().then(function () {
          showToast((productTitle || 'Item') + ' added to cart 🐾');
          openCart();
        });
      })
      .catch(function (err) {
        showToast((err && err.description) ? err.description : 'Could not add that item.');
      });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-pp-cart-open]');
    if (openBtn) { e.preventDefault(); fetchCart().then(openCart); return; }

    var closeBtn = e.target.closest('[data-pp-cart-close]');
    if (closeBtn) { e.preventDefault(); closeCart(); return; }

    var addBtn = e.target.closest('[data-pp-add]');
    if (addBtn) {
      e.preventDefault();
      var vid = addBtn.getAttribute('data-pp-add');
      if (!vid) { showToast('This item is unavailable.'); return; }
      addBtn.classList.add('is-pop');
      setTimeout(function () { addBtn.classList.remove('is-pop'); }, 350);
      addToCart(vid, 1, addBtn.getAttribute('data-pp-title'));
      return;
    }

    var qtyBtn = e.target.closest('[data-pp-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var action = qtyBtn.getAttribute('data-pp-qty');
      var currentEl = qtyBtn.parentElement ? qtyBtn.parentElement.querySelector('span') : null;
      var current = currentEl ? parseInt(currentEl.textContent, 10) : 1;
      if (action === 'inc') changeLine(line, current + 1);
      if (action === 'dec') changeLine(line, Math.max(0, current - 1));
      if (action === 'remove') changeLine(line, 0);
      return;
    }
  });

  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ---------- product form (product page) ---------- */
  var productForm = document.getElementById('ppProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = productForm.querySelector('[name="id"]');
      var qtyInput = productForm.querySelector('[name="quantity"]');
      if (!variantInput || !variantInput.value) { showToast('Please choose an option first.'); return; }
      addToCart(variantInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1, productForm.getAttribute('data-product-title'));
    });

    var qtyMinus = productForm.querySelector('[data-pp-qty-minus]');
    var qtyPlus = productForm.querySelector('[data-pp-qty-plus]');
    var qtyField = productForm.querySelector('[name="quantity"]');
    if (qtyMinus && qtyField) qtyMinus.addEventListener('click', function () {
      qtyField.value = Math.max(1, parseInt(qtyField.value, 10) - 1);
    });
    if (qtyPlus && qtyField) qtyPlus.addEventListener('click', function () {
      qtyField.value = parseInt(qtyField.value, 10) + 1;
    });

    // variant selection
    var variantSelects = productForm.querySelectorAll('[data-pp-option]');
    var variantData = window.ppVariants || [];
    var hiddenId = productForm.querySelector('[name="id"]');
    var priceEl = document.getElementById('ppProductPrice');
    var submitBtn = productForm.querySelector('[type="submit"]');

    function updateVariant() {
      var chosen = [];
      variantSelects.forEach(function (s) { chosen.push(s.value); });
      var match = variantData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (match) {
        hiddenId.value = match.id;
        if (priceEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            priceEl.innerHTML = '<span class="was">' + formatMoney(match.compare_at_price) + '</span>' + formatMoney(match.price);
          } else {
            priceEl.textContent = formatMoney(match.price);
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !match.available;
          var span = submitBtn.querySelector('span');
          if (span) span.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      }
    }
    variantSelects.forEach(function (s) { s.addEventListener('change', updateVariant); });
    if (variantSelects.length) updateVariant();

  }

  /* ---------- product gallery + lightbox ---------- */
  var mainImg = document.getElementById('ppMainImage');
  var viewport = document.getElementById('ppViewport');
  var modelWrap = document.getElementById('ppModelWrap');
  var thumbs = document.querySelectorAll('[data-pp-thumb]');
  var modelThumb = document.querySelector('[data-pp-show-model]');
  var currentIndex = 0;

  function showImageStage() {
    if (viewport) viewport.hidden = false;
    if (modelWrap) modelWrap.hidden = true;
  }
  function showModelStage() {
    if (viewport) viewport.hidden = true;
    if (modelWrap) modelWrap.hidden = false;
    document.querySelectorAll('.pp-product__thumb').forEach(function (x) { x.classList.remove('is-active'); });
    if (modelThumb) modelThumb.classList.add('is-active');
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var src = t.getAttribute('data-pp-thumb');
      var idx = parseInt(t.getAttribute('data-pp-index'), 10);
      if (mainImg && src) {
        viewport.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = function () {
          mainImg.src = src;
          mainImg.setAttribute('data-full', t.getAttribute('data-pp-full') || src);
          viewport.classList.remove('is-swapping');
        };
        pre.src = src;
      }
      if (!isNaN(idx)) currentIndex = idx;
      showImageStage();
      document.querySelectorAll('.pp-product__thumb').forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  if (modelThumb) modelThumb.addEventListener('click', showModelStage);

  // --- lightbox ---
  var lb = document.getElementById('ppLightbox');
  // guard: a stale cached stylesheet could leave this overlay covering the page
  if (lb && lb.hidden) lb.style.display = 'none';
  if (lb && mainImg) {
    var lbImg = document.getElementById('ppLbImage');
    var lbStage = document.getElementById('ppLbStage');
    var lbCounter = document.getElementById('ppLbCounter');
    var lbZoomLabel = document.getElementById('ppLbZoom');
    var gallery = window.ppGallery || [];
    var scale = 1, tx = 0, ty = 0;
    var dragging = false, startX = 0, startY = 0;
    var MIN = 1, MAX = 4;

    function applyTransform() {
      lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      if (lbZoomLabel) lbZoomLabel.textContent = Math.round(scale * 100) + '%';
      lbStage.classList.toggle('is-zoomed', scale > 1);
    }
    function resetZoom() { scale = 1; tx = 0; ty = 0; applyTransform(); }

    function loadIndex(i) {
      if (!gallery.length) return;
      currentIndex = (i + gallery.length) % gallery.length;
      lbImg.src = gallery[currentIndex].full;
      lbImg.alt = gallery[currentIndex].alt || '';
      if (lbCounter) lbCounter.textContent = (currentIndex + 1) + ' / ' + gallery.length;
      resetZoom();
      var navs = lb.querySelectorAll('.pp-lb-nav');
      navs.forEach(function (n) { n.style.display = gallery.length > 1 ? '' : 'none'; });
    }

    function openLightbox() {
      if (!gallery.length) {
        gallery = [{ full: mainImg.getAttribute('data-full') || mainImg.src, alt: mainImg.alt }];
      }
      lb.hidden = false;
      lb.style.display = '';
      requestAnimationFrame(function () { lb.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      loadIndex(currentIndex);
    }
    function closeLightbox() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () {
        lb.hidden = true;
        lb.style.display = 'none';
      }, 300);
    }

    if (viewport) viewport.addEventListener('click', function (e) {
      if (e.target.closest('[data-pp-lightbox-open]') || e.target === mainImg) openLightbox();
    });

    lb.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pp-lb]');
      if (btn) {
        var action = btn.getAttribute('data-pp-lb');
        if (action === 'close') closeLightbox();
        if (action === 'next') loadIndex(currentIndex + 1);
        if (action === 'prev') loadIndex(currentIndex - 1);
        if (action === 'reset') resetZoom();
        if (action === 'zoomin') { scale = Math.min(MAX, scale + 0.5); applyTransform(); }
        if (action === 'zoomout') { scale = Math.max(MIN, scale - 0.5); if (scale === 1) { tx = 0; ty = 0; } applyTransform(); }
        return;
      }
      if (e.target === lbStage || e.target === lb) closeLightbox();
    });

    // click image to toggle zoom
    lbImg.addEventListener('click', function (e) {
      e.stopPropagation();
      if (scale > 1) { resetZoom(); } else { scale = 2.2; applyTransform(); }
    });

    // wheel zoom
    lbStage.addEventListener('wheel', function (e) {
      if (lb.hidden) return;
      e.preventDefault();
      var delta = e.deltaY > 0 ? -0.25 : 0.25;
      scale = Math.min(MAX, Math.max(MIN, scale + delta));
      if (scale === 1) { tx = 0; ty = 0; }
      applyTransform();
    }, { passive: false });

    // drag to pan
    lbStage.addEventListener('pointerdown', function (e) {
      if (scale <= 1) return;
      dragging = true;
      startX = e.clientX - tx;
      startY = e.clientY - ty;
      lbStage.classList.add('is-dragging');
      lbStage.setPointerCapture(e.pointerId);
    });
    lbStage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      tx = e.clientX - startX;
      ty = e.clientY - startY;
      applyTransform();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      lbStage.addEventListener(ev, function () {
        dragging = false;
        lbStage.classList.remove('is-dragging');
      });
    });

    // pinch zoom
    var pinchStart = null;
    lbStage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pinchStart = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        ) / scale;
      }
    }, { passive: true });
    lbStage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinchStart) {
        e.preventDefault();
        var dist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        scale = Math.min(MAX, Math.max(MIN, dist / pinchStart));
        if (scale === 1) { tx = 0; ty = 0; }
        applyTransform();
      }
    }, { passive: false });
    lbStage.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) pinchStart = null;
    });

    // keyboard
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') loadIndex(currentIndex + 1);
      if (e.key === 'ArrowLeft') loadIndex(currentIndex - 1);
      if (e.key === '+' || e.key === '=') { scale = Math.min(MAX, scale + 0.5); applyTransform(); }
      if (e.key === '-') { scale = Math.max(MIN, scale - 0.5); if (scale === 1) { tx = 0; ty = 0; } applyTransform(); }
      if (e.key === '0') resetZoom();
    });
  }

  /* ---------- catalog filters ---------- */
  var grid = document.getElementById('ppProductGrid');
  if (grid) {
    var pills = document.querySelectorAll('[data-pp-filter]');
    var saleOnlyEl = document.getElementById('ppSaleOnly');
    var searchEl = document.getElementById('ppSearch');
    var sortEl = document.getElementById('ppSort');
    var emptyEl = document.getElementById('ppNoResults');

    function applyFilters() {
      var activePill = document.querySelector('[data-pp-filter].is-active');
      var cat = activePill ? activePill.getAttribute('data-pp-filter') : 'all';
      var saleOnly = saleOnlyEl ? saleOnlyEl.checked : false;
      var term = searchEl ? searchEl.value.toLowerCase().trim() : '';
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-pp-product]'));
      var visible = 0;

      cards.forEach(function (card) {
        var cardCats = (card.getAttribute('data-collections') || '').split(',');
        var onSale = card.getAttribute('data-on-sale') === 'true';
        var title = (card.getAttribute('data-title') || '').toLowerCase();
        var show = true;
        if (cat !== 'all' && cardCats.indexOf(cat) === -1) show = false;
        if (saleOnly && !onSale) show = false;
        if (term && title.indexOf(term) === -1) show = false;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      if (sortEl && sortEl.value !== 'featured') {
        var sorted = cards.slice().sort(function (a, b) {
          var pa = parseFloat(a.getAttribute('data-price')) || 0;
          var pb = parseFloat(b.getAttribute('data-price')) || 0;
          return sortEl.value === 'low' ? pa - pb : pb - pa;
        });
        sorted.forEach(function (c) { grid.appendChild(c); });
      }

      if (emptyEl) emptyEl.hidden = visible !== 0;
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        pills.forEach(function (x) { x.classList.remove('is-active'); });
        p.classList.add('is-active');
        applyFilters();
      });
    });
    if (saleOnlyEl) saleOnlyEl.addEventListener('change', applyFilters);
    if (searchEl) searchEl.addEventListener('input', applyFilters);
    if (sortEl) sortEl.addEventListener('change', applyFilters);
  }

  /* ---------- mobile menu ---------- */
  var burger = document.getElementById('ppBurger');
  var mobileMenu = document.getElementById('ppMobileMenu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      burger.classList.toggle('is-open');
      mobileMenu.classList.toggle('is-open');
      var isOpen = mobileMenu.classList.contains('is-open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // close the menu with Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        burger.classList.remove('is-open');
        mobileMenu.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        burger.classList.remove('is-open');
        mobileMenu.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- scroll: progress bar + cat mascot ---------- */
  var progress = document.getElementById('ppProgress');
  var cat = document.getElementById('ppCat');
  var catShadow = document.getElementById('ppCatShadow');
  var catArt = cat ? cat.querySelector('svg, .pp-cat-photo, .pp-cat-sprite') : null;
  var lastScrollY = window.scrollY || 0;
  var catFacingRight = false;
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var frac = max > 0 ? h.scrollTop / max : 0;
      if (progress) progress.style.width = (frac * 100) + '%';
      if (cat) {
        // walk from the right edge to the left edge as the page scrolls down
        var travel = window.innerWidth + 160;
        var x = (window.innerWidth + 80) - frac * travel;
        cat.style.transform = 'translateX(' + x + 'px)';
        if (catShadow) catShadow.style.transform = 'translateX(' + (x - 12) + 'px)';

        // turn to face the way it is travelling.
        // scrolling down moves it left (the artwork already faces left);
        // scrolling up moves it right, so mirror it.
        var y = h.scrollTop;
        if (Math.abs(y - lastScrollY) > 2) {
          var facingRight = y < lastScrollY;
          if (facingRight !== catFacingRight) {
            catFacingRight = facingRight;
            if (catArt) catArt.style.transform = 'scaleX(' + (facingRight ? -1 : 1) + ')';
          }
          lastScrollY = y;
        }
      }
      ticking = false;
    });
  }
  document.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- scroll-story background ---------- */
  var bgFixed = document.getElementById('ppBgFixed');
  var zones = document.querySelectorAll('[data-pp-bg]');
  if (bgFixed && zones.length) {
    var layers = {};
    zones.forEach(function (z, i) {
      var url = z.getAttribute('data-pp-bg');
      if (!url) return;
      var layer = document.createElement('div');
      layer.className = 'pp-bg-layer' + (i === 0 ? ' is-active' : '');
      layer.style.backgroundImage = 'url(' + url + ')';
      bgFixed.appendChild(layer);
      layers[z.id || ('zone' + i)] = layer;
      z.setAttribute('data-pp-bg-key', z.id || ('zone' + i));
    });

    var bgIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var key = entry.target.getAttribute('data-pp-bg-key');
        Object.keys(layers).forEach(function (k) {
          layers[k].classList.toggle('is-active', k === key);
        });
      });
    }, { threshold: 0.35 });
    zones.forEach(function (z) { bgIO.observe(z); });
  }

  /* ---------- reveal on scroll ---------- */
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.pp-reveal').forEach(function (el) { revealIO.observe(el); });

  /* ---------- count-up stats ---------- */
  var statIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      var target = parseFloat(el.getAttribute('data-count'));
      var suffix = el.getAttribute('data-suffix') || '';
      if (isNaN(target)) { statIO.unobserve(el); return; }
      var isFloat = target % 1 !== 0;
      // the real value is already in the HTML for crawlers; reset to 0 only for the animation
      el.textContent = '0' + suffix;
      var cur = 0, steps = 40, inc = target / steps, i = 0;
      var timer = setInterval(function () {
        i++; cur += inc;
        if (i >= steps) { cur = target; clearInterval(timer); }
        el.textContent = (isFloat ? cur.toFixed(1) : Math.round(cur)) + suffix;
      }, 30);
      statIO.unobserve(el);
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-count]').forEach(function (el) { statIO.observe(el); });

  /* ---------- card tilt (fine pointer only) ---------- */
  var isFine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if (isFine) {
    document.addEventListener('mousemove', function (e) {
      var card = e.target.closest('.pp-card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(700px) rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 8) + 'deg) translateY(-6px)';
    });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest('.pp-card');
      if (card && !card.contains(e.relatedTarget)) card.style.transform = '';
    });
  }

  // keep the drawer in sync on load
  if (itemsEl) fetchCart();
})();

/* ===== WhatsApp product share tool ===== */
(function () {
  var sel = document.getElementById('ppShareProduct');
  if (!sel) return;

  var dest = document.getElementById('ppShareDest');
  var msg = document.getElementById('ppShareMessage');
  var sendBtn = document.getElementById('ppShareSend');
  var copyBtn = document.getElementById('ppShareCopy');
  var tpl = window.ppShareTemplate || '[TITLE]\n[PRICE]\n[URL]';

  function build() {
    var opt = sel.options[sel.selectedIndex];
    if (!opt || !opt.value) { msg.value = ''; return; }
    var was = opt.getAttribute('data-compare') || '';
    var price = opt.getAttribute('data-price') || '';
    var text = tpl
      .replace(/\[TITLE\]/g, opt.getAttribute('data-title') || '')
      .replace(/\[PRICE\]/g, was ? (was + ' → ' + price) : price)
      .replace(/\[WAS\]/g, was)
      .replace(/\[URL\]/g, opt.getAttribute('data-url') || '');
    msg.value = text;
  }

  sel.addEventListener('change', build);

  sendBtn.addEventListener('click', function () {
    if (!msg.value.trim()) {
      if (window.ppToast) window.ppToast('Pick a product first.');
      return;
    }
    var opt = dest.options[dest.selectedIndex];
    var kind = opt ? opt.getAttribute('data-kind') : 'share';

    if (kind === 'link') {
      // open the channel/group so you can paste, and copy the text ready
      navigator.clipboard && navigator.clipboard.writeText(msg.value);
      if (window.ppToast) window.ppToast('Message copied — paste it in the chat that opens.');
      window.open(opt.value, '_blank', 'noopener');
    } else if (kind === 'broadcast') {
      navigator.clipboard && navigator.clipboard.writeText(msg.value);
      if (window.ppToast) window.ppToast('Message copied — paste it into your broadcast list.');
    } else {
      window.open('https://wa.me/?text=' + encodeURIComponent(msg.value), '_blank', 'noopener');
    }
  });

  copyBtn.addEventListener('click', function () {
    if (!msg.value.trim()) return;
    navigator.clipboard.writeText(msg.value).then(function () {
      if (window.ppToast) window.ppToast('Message copied to clipboard');
    });
  });
})();

/* ===== Instagram video section ===== */
(function () {
  var grid = document.querySelector('[data-pp-ig-autoplay]');
  if (!grid) return;

  var mode = grid.getAttribute('data-pp-ig-autoplay') || 'inview';
  var videos = grid.querySelectorAll('video');
  if (!videos.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isFinePointer = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  videos.forEach(function (v) {
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.removeAttribute('controls');
  });

  function safePlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  if (mode !== 'off' && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        var playOnHoverOnly = (mode === 'hover' && isFinePointer);
        if (entry.isIntersecting) {
          if (!playOnHoverOnly) safePlay(v);
        } else {
          v.pause();
          if (!v.muted) {
            v.muted = true;
            var card = v.closest('.pp-ig-card');
            if (card) syncSoundIcon(card, true);
          }
        }
      });
    }, { threshold: 0.4 });
    videos.forEach(function (v) { io.observe(v); });

    if (mode === 'hover' && isFinePointer) {
      grid.querySelectorAll('.pp-ig-card').forEach(function (card) {
        var v = card.querySelector('video');
        if (!v) return;
        card.addEventListener('mouseenter', function () { safePlay(v); });
        card.addEventListener('mouseleave', function () { v.pause(); });
      });
    }
  }

  function syncSoundIcon(card, muted) {
    var btn = card.querySelector('[data-pp-ig-sound]');
    if (!btn) return;
    var off = btn.querySelector('.pp-ig-sound__off');
    var on = btn.querySelector('.pp-ig-sound__on');
    if (off) off.hidden = !muted;
    if (on) on.hidden = muted;
    btn.classList.toggle('is-on', !muted);
  }

  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pp-ig-sound]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('.pp-ig-card');
    var v = card ? card.querySelector('video') : null;
    if (!v) return;

    if (v.muted) {
      // only one video with sound at a time
      videos.forEach(function (other) {
        if (other !== v && !other.muted) {
          other.muted = true;
          var oc = other.closest('.pp-ig-card');
          if (oc) syncSoundIcon(oc, true);
        }
      });
      v.muted = false;
      safePlay(v);
    } else {
      v.muted = true;
    }
    syncSoundIcon(card, v.muted);
  });
})();

/* ===== collection filters ===== */
(function () {
  var form = document.getElementById('ppFilterForm');
  if (!form) return;

  var toggle = form.querySelector('[data-pp-filters-toggle]');
  var panel = document.getElementById('ppFilterPanel');

  if (toggle && panel) {
    // open by default on desktop when filters are already applied
    var hasActive = !!form.querySelector('.pp-active-filters');
    if (hasActive && window.innerWidth > 900) {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }
    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // checkbox / sort changes apply immediately
  form.addEventListener('change', function (e) {
    if (e.target.hasAttribute('data-pp-auto-submit')) {
      form.submit();
    }
  });

  // price inputs apply on Enter or when leaving the field
  form.querySelectorAll('.pp-filter-price input').forEach(function (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); form.submit(); }
    });
  });

  // never submit empty price fields as blank params
  form.addEventListener('submit', function () {
    form.querySelectorAll('input[type="number"]').forEach(function (i) {
      if (i.value === '') i.disabled = true;
    });
  });
})();

/* ===== header search overlay with live suggestions ===== */
(function () {
  var overlay = document.getElementById('ppSearch');
  if (!overlay) return;

  var input = document.getElementById('ppSearchInput');
  var form = document.getElementById('ppSearchForm');
  var results = document.getElementById('ppSearchResults');
  var status = document.getElementById('ppSearchStatus');
  var clearBtn = overlay.querySelector('[data-pp-search-clear]');
  var idleBlocks = overlay.querySelectorAll('[data-pp-search-idle]');
  var lastFocus = null;
  var debounce = null;
  var controller = null;
  var activeIndex = -1;

  function open() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 120);
  }
  function close() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 300);
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pp-search-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-pp-search-close]')) { e.preventDefault(); close(); return; }
    var term = e.target.closest('[data-pp-search-term]');
    if (term) {
      input.value = term.getAttribute('data-pp-search-term');
      input.focus();
      run(input.value);
    }
  });

  document.addEventListener('keydown', function (e) {
    // "/" opens search, like most storefronts
    if (e.key === '/' && !/(INPUT|TEXTAREA|SELECT)/.test(document.activeElement.tagName) && overlay.hidden) {
      e.preventDefault(); open(); return;
    }
    if (overlay.hidden) return;
    if (e.key === 'Escape') { close(); return; }

    var items = results.querySelectorAll('.pp-search__result');
    if (!items.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      activeIndex += (e.key === 'ArrowDown' ? 1 : -1);
      if (activeIndex < 0) activeIndex = items.length - 1;
      if (activeIndex >= items.length) activeIndex = 0;
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === activeIndex); });
      items[activeIndex].scrollIntoView({ block: 'nearest' });
    }
    if (e.key === 'Enter' && activeIndex > -1) {
      e.preventDefault();
      window.location.href = items[activeIndex].getAttribute('href');
    }
  });

  function setIdleVisible(visible) {
    idleBlocks.forEach(function (b) { b.hidden = !visible; });
  }

  function money(cents) {
    if (window.ppMoneyFormat) {
      return window.ppMoneyFormat.replace(/\{\{\s*\w+\s*\}\}/, (cents / 100).toFixed(2));
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function render(products, query) {
    activeIndex = -1;
    if (!products.length) {
      results.hidden = true;
      status.hidden = false;
      status.textContent = 'No products match “' + query + '”. Try a different word.';
      return;
    }
    status.hidden = true;
    results.hidden = false;
    results.innerHTML = products.slice(0, 6).map(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') + '" alt="" loading="lazy">'
        : '<img src="" alt="">';
      var price = p.price_min !== undefined ? p.price_min : p.price;
      var compare = p.compare_at_price_min || 0;
      var priceHtml = (compare && compare > price)
        ? '<span class="was">' + money(compare) + '</span>' + money(price)
        : money(price);
      return '<a class="pp-search__result" href="' + p.url + '">' +
        img +
        '<span class="pp-search__result-info">' +
          '<span class="pp-search__result-title">' + p.title + '</span>' +
          '<span class="pp-search__result-price">' + priceHtml + '</span>' +
        '</span>' +
      '</a>';
    }).join('') +
    '<a class="pp-search__viewall" href="/search?q=' + encodeURIComponent(query) + '&type=product">See all results for “' + query + '”</a>';
  }

  function run(query) {
    query = (query || '').trim();
    if (query.length < 2) {
      results.hidden = true;
      status.hidden = true;
      setIdleVisible(true);
      return;
    }
    setIdleVisible(false);
    status.hidden = false;
    status.textContent = 'Searching…';
    results.hidden = true;

    if (controller) controller.abort();
    controller = new AbortController();

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(products, query);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        // if suggestions fail, fall back to the normal search page
        status.hidden = false;
        status.textContent = 'Press Enter to search for “' + query + '”.';
      });
  }

  if (input) {
    input.addEventListener('input', function () {
      clearBtn.hidden = input.value.length === 0;
      clearTimeout(debounce);
      var suggestionsOn = overlay.getAttribute('data-suggestions') !== 'false';
      if (!suggestionsOn) return;
      debounce = setTimeout(function () { run(input.value); }, 220);
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      input.focus();
      run('');
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });
  }
})();
